import React from 'react';
import {WrapperModalDialog} from './ModalDialog';
import _ from 'lodash';
import '../../assets/css/companylist.css';
import '../../assets/css/intray.css';

export const signInAndLinkModel = (showSignIn: boolean, sendIntrayErrorMessage: boolean, clickedSignIn: boolean, invoice: any,
                                   closeSelectCompany: () => void, sendToInTray: () => void) => {
    const popTitle = 'If you\'re not seeing anything, please check your pop up blocker'
    const checkLogin = 'Check back on this page once you\'ve logged in'
    const noLoginText = 'Don\'t have an MYOB account?'

    return (
        <WrapperModalDialog show={showSignIn} close={closeSelectCompany} title={'Link To MYOB'}
                            titleCenter={true} id={'signin'}>
            <div className='modal-body'>
                {sendIntrayErrorMessage &&
                    <div className='error text-danger'>
                        <i className='icon-error'></i><label>Sorry, something went wrong. Please close this window and
                        try again.</label>
                    </div>
                }
                <div id='signInImage'>
                    {!clickedSignIn && <div>
                        <img src={require('../../assets/img/empty-invoice-list.png')}/>
                    </div>}
                    {clickedSignIn && <div>
                        <img src={require('../../assets/img/Filing-Cabinet-Document-Remove.png')}/>
                    </div>}
                </div>
                <div style={{textAlign: 'center', width: '70%', margin: 'auto'}}>
                    {!clickedSignIn &&
                        <div>
                            <strong>
                                <h4 style={{lineHeight: '120%'}}> Sign in and get all of your {
                                    invoice.company.name
                                } invoices sent to your MYOB file. </h4>
                            </strong>
                            <p>All of your {invoice.company.name} invoices will be sent to your In tray so you
                                can link them to transactions or use them to create bills.</p>
                        </div>}
                    {clickedSignIn &&
                        <div>
                            <strong>
                                <h4 style={{lineHeight: '120%'}}> Redirecting you to the MYOB login page </h4>
                            </strong>
                            <p>Hang tight! A new window should appear any second now.<br/> {popTitle} <br/> {checkLogin}
                            </p>
                        </div>}
                </div>
                <div style={{textAlign: 'center', marginTop: '30px'}}>
                    {!clickedSignIn &&
                        <div>
                            <p style={{display: 'inline-block', marginBottom: '0px'}}>{noLoginText}</p>
                            <a style={{color: '#8241AA'}} href='https://www.myob.com/au/accounting-software/free-trial' target='_blank'
                            rel='noopener noreferrer'>&nbsp;Sign
                            up
                            for a free trial</a>
                        </div>
                    }
                </div>
            </div>
            <div className='modal-footer'>
                {!clickedSignIn && !sendIntrayErrorMessage &&
                    <button type='button' className='btn btn-primary' id='signInToMyob' onClick={sendToInTray}>Sign in
                        to MYOB
                    </button>}
            </div>
        </WrapperModalDialog>
    );
}

export const sendInTray = (showSendInTray: boolean, sendIntrayErrorMessage: boolean, loadingIntray: boolean, inTrayLinked: boolean, showSendInTrayLoginModal: boolean, companyId: string,
                           invoice: any, companyList: any[], closeSelectCompany: () => void, removeLinkFromMYOB: () => void, confirmCompany: () => void, selectCompany: (link: string) => void) => {
    const title = !loadingIntray && inTrayLinked ? 'Success!' : 'Link to MYOB'
    const linkMyob = 'You\'ve linked your MYOB account to'
    const unableFindBusiness = 'We\'re unable to find your business'
    const enterBusiness = 'Make sure you\'ve correctly entered your business details'
    return (
        <WrapperModalDialog show={showSendInTray} close={closeSelectCompany} title={title}
                            titleCenter={true} id={'sendintray'}>
            <div className='modal-body'>
                {sendIntrayErrorMessage && <div className='error text-danger'>
                    <i className='icon-error'></i><label>Sorry, something went wrong. Please close
                    this window and try again.</label>
                </div>
                }
                {!loadingIntray && inTrayLinked &&
                    <div>
                        {!loadingIntray && <div id='linkedImage'>
                            <img src={require('../../assets/img/success.png')} width='50%' height='50%'
                                 style={{display: 'block', margin: '0 auto'}}/>
                        </div>
                        }
                        <div style={{textAlign: 'center', width: '70%', margin: 'auto'}}>
                            {!loadingIntray && <div>
                                <strong>
                                    <h4 style={{fontWeight: 'bolder', lineHeight: '120%'}}>{linkMyob}
                                        <br/> {invoice.company.name}.</h4>
                                </strong>
                                <p>Every time we detect a {invoice.company.name} invoice, we will send it to your In
                                    tray at the end of that business day.</p>
                            </div>
                            }
                        </div>
                        <div style={{textAlign: 'center', marginTop: '20px', marginBottom: '50px'}}>
                            {!loadingIntray && <div>
                                <a target='_blank' style={{color: '#8241AA'}} rel='noopener noreferrer'
                                   href='http://help.myob.com/wiki/display/ea/Working+with+in+tray+documents'>Learn more
                                    about the In tray</a>
                            </div>}
                        </div>
                    </div>
                }
                {!showSendInTrayLoginModal && !inTrayLinked && <div id='companyListModalBody'>
                    {companyList.length === 0 && <div>
                        <div>
                            <img src={require('../../assets/img/error-construction.png').default}
                                 style={{display: 'block', margin: '0 auto'}}/>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <h4> {unableFindBusiness} </h4>
                            <p> {enterBusiness} <br/> in your MYOB software, and try applying again. <br/><br/>If you
                                continue having this issue, please contact us.</p>
                        </div>
                    </div>
                    }
                    {companyList.length > 0 && !loadingIntray && <div>
                        <div style={{textAlign: 'center', width: '70%', margin: 'auto', paddingBottom: '20px'}}>
                            <img id='companyListImage' src={require('../../assets/img/Laptop-MYOB.png')}/>
                            <p><br/>Where should we send your invoices?</p>
                        </div>
                        <ul>
                            {companyList.map(company => {
                                const value = `${company.uid},${company.productName},${company.serialNumber}`
                                return (
                                    <li key={company.uid} className='list-group-item'>
                                        <label htmlFor={company.uid} className='radio-item'>
                                            {companyList.length === 1 &&
                                                <input type='radio' id={company.uid} name='company'
                                                       value={value}
                                                       onClick={event => {
                                                           selectCompany(_.get(event.target, value, ""))
                                                       }}
                                                       checked={value === companyId}/>}
                                            {companyList.length > 1 &&
                                                <input type='radio' id={company.uid} name='company'
                                                       value={value}
                                                       onClick={event => {
                                                           selectCompany(_.get(event.target, value, ""))
                                                       }}
                                                       checked={value === companyId}/>
                                            }
                                            <div className='companyListValue'><span
                                                className='companyMame'>{company.name
                                            }</span><br/><span className='companyProduct'>{company.product}</span></div>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>}
                </div>}
                {loadingIntray && !sendIntrayErrorMessage && <div>
                    <div className='loading_intray text-center'>
                        <div className='flx-loading-spinner-lg'/>
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <h4> Connecting you to MYOB </h4>
                    </div>
                </div>}
            </div>
            <div className='modal-footer'>
                {!loadingIntray &&
                    <div>
                        {inTrayLinked &&
                            <button type='button' className='btn btn-default' onClick={closeSelectCompany}>Close
                            </button>}
                        {inTrayLinked &&
                            <button type='button' className='btn btn-danger' id='unlinkFromMYOB'
                                    onClick={removeLinkFromMYOB}
                                    style={{backgroundColor: '#CE2554', borderColor: '#CE2554'}}>Unlink your account
                            </button>}
                        {!showSendInTrayLoginModal && companyList.length > 0 && !inTrayLinked &&
                            <button type='button' className='btn btn-primary' id='companyListSubmit'
                                    onClick={confirmCompany}>Finish
                            </button>
                        }
                    </div>
                }
            </div>
        </WrapperModalDialog>
    );

}

export const unLinkModel = (showUnlink: boolean, sendIntrayErrorMessage: boolean, loadingIntray: boolean, inTrayLinked: boolean, invoice: any,
                            closeUnlink: () => void, unlinkFromInTray: () => void) => {
    const unlinkAlertTitle = 'You\'ll no longer receive invoices from'
    const unlinkText = 'You\'ve been unlinked'

    return (
        <WrapperModalDialog show={showUnlink} close={closeUnlink} title={'Unlink from MYOB'}
                            titleCenter={true} id={'unlink'}>
            <div className='modal-body'>
                {sendIntrayErrorMessage && <div className='error text-danger'>
                    <i className='icon-error'></i><label>Sorry, something went wrong. Please close
                    this window and try again.</label>
                </div>}
                <div id='unlinkedImage'>
                    {!loadingIntray && inTrayLinked &&
                        <div>
                            <img src={require('../../assets/img/Home-Office.png')}
                                 style={{display: "block", margin: '0 auto'}}/>
                        </div>
                    }
                    {!loadingIntray && !inTrayLinked && <div>
                        <img src={require('../../assets/img/success.png')} width='50%'
                             style={{display: 'block', margin: '0 auto'}}/>
                    </div>}
                </div>

                <div style={{textAlign: 'center', width: '70%', margin: 'auto'}}>
                    {!loadingIntray && inTrayLinked &&
                        <div>
                            <strong>
                                <h4 style={{fontWeight: 'bolder', lineHeight: '120%'}}>Unlink your account
                                    from {invoice.company.name}?</h4>
                            </strong>
                            <p>Select <strong>Unlink</strong> to stop receiving invoices from {invoice.company.name} in
                                your In&nbsp;tray.</p>
                        </div>
                    }
                    {!loadingIntray && !inTrayLinked &&
                        <div>
                            <strong>
                                <h4 style={{fontWeight: 'bolder', lineHeight: '120%'}}>{unlinkText}</h4>
                            </strong>
                            <p>{unlinkAlertTitle}{invoice.company.name} in your In&nbsp;tray.<br/>To
                                link accounts again,
                                select <strong>Link&nbsp;to&nbsp;MYOB</strong> in any {invoice.company.name} invoice.
                            </p>
                        </div>
                    }
                </div>
                {!loadingIntray && inTrayLinked &&
                    <div
                        style={{textAlign: 'center', marginTop: '20px', marginBottom: '50px'}}>
                        <a style={{color: '#8241AA'}} href='http://help.myob.com/wiki/display/ea/Working+with+in+tray+documents'
                           rel='noopener noreferrer' target='_blank'>Learn
                            more about the In tray</a>
                    </div>
                }
                {loadingIntray && !sendIntrayErrorMessage &&
                    <div>
                        <div className='loading_intray text-center'>
                            <div className='flx-loading-spinner-lg'/>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <h4> Connecting you to MYOB </h4>
                        </div>
                    </div>}

            </div>
            <div className='modal-footer'>
                {!loadingIntray && !sendIntrayErrorMessage &&
                    <div>
                        {inTrayLinked &&
                            <button style={{marginRight: 3}} type='button' className='btn btn-default' onClick={closeUnlink}>Cancel</button>}
                        {!inTrayLinked &&
                            <button style={{marginRight: 3}} type='button' className='btn btn-default' onClick={closeUnlink}>Close</button>}
                        {inTrayLinked &&
                            <button type='button' className='btn btn-danger' onClick={unlinkFromInTray}
                                    style={{backgroundColor: '#CE2554', borderColor: '#CE2554'}}>Unlink</button>
                        }
                    </div>
                }
            </div>
        </WrapperModalDialog>
    );
}


